export default __webpack_public_path__ + "static/author1-cc0558b91294ec5fe5a9b79d1db3edee.jpg";